import actionCombined from "./actionCombined";
import { combineReducers } from "redux";

const mainReducer = combineReducers({
  actionCombined,
});

export default mainReducer;
